import { render, staticRenderFns } from "./PosList.vue?vue&type=template&id=2b03bf8b&scoped=true"
import script from "./PosList.vue?vue&type=script&lang=js"
export * from "./PosList.vue?vue&type=script&lang=js"
import style0 from "./PosList.vue?vue&type=style&index=0&id=2b03bf8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b03bf8b",
  null
  
)

export default component.exports